@let moduleValue = module();
@let isTooltipRightAlignedValue = isTooltipRightAligned();

<button
  type="button"
  class="launcher-item"
  [disableTooltip]="isFullTextDisplayed(moduleName)"
  [kdsTooltip]="moduleValue.moduleName"
  [tooltipPosition]="isTooltipRightAlignedValue ? 'bottom-right' : 'bottom-left'"
  (click)="openModule()"
>
  <img class="launcher-item__icon" height="32" width="32" [ngSrc]="moduleValue.moduleImageUrl" [alt]="moduleValue.moduleName" />
  <span class="launcher-item__text-container">
    <span #moduleName class="launcher-item__text">
      {{ moduleValue.moduleName }}
    </span>
  </span>

  @if (moduleValue.isTrial) {
    <span class="launcher-item__trial-badge">
      <kds-tag colorVariant="subtle-success" size="small">{{ 'general.trial' | translate }}</kds-tag>
    </span>
  }

  @if (isMultipleTenants()) {
    <i
      class="launcher-item__tenants-icon fa-regular fa-rectangle-history"
      [kdsTooltip]="'launcher.choose-instance' | translate"
      [tooltipPosition]="isTooltipRightAlignedValue ? 'top-right' : 'top-left'"
    ></i>
  }
</button>
